import MuiDialog from 'components/MuiDialog';
import {
  SurveyDialogProps,
  TCoreNursingSkillVideoDefaultValues as TCoreNursingSkillVideoDeExemplefaultValues,
} from 'routes/Main/Survey/type';
import { Grid, Typography } from '@mui/material';
import Contents1 from './Contents1';
import Contents2 from './Contents2';

const VoiceEMR = (
  props: SurveyDialogProps<TCoreNursingSkillVideoDeExemplefaultValues>
) => {
  const { title, isOpen, onClose } = props;

  return (
    <MuiDialog.SurveyFormTwo title={title} isOpen={isOpen} onClose={onClose}>
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          Voice EMR
        </Typography>
        <Contents1 />
        <Contents2 />
      </Grid>
    </MuiDialog.SurveyFormTwo>
  );
};

export default VoiceEMR;
